const actions = {

  FETCH_EXPORT_SETTINGS_BEGIN: 'FETCH_EXPORT_SETTINGS_BEGIN',
  FETCH_EXPORT_SETTINGS_SUCCESS: 'FETCH_EXPORT_SETTINGS_SUCCESS',
  FETCH_EXPORT_SETTINGS_ERR: 'FETCH_EXPORT_SETTINGS_ERR',

  UPDATE_EXPORT_SETTINGS_BEGIN: 'UPDATE_EXPORT_SETTINGS_BEGIN',
  UPDATE_EXPORT_SETTINGS_SUCCESS: 'UPDATE_EXPORT_SETTINGS_SUCCESS',
  UPDATE_EXPORT_SETTINGS_ERR: 'UPDATE_EXPORT_SETTINGS_ERR',

  GET_EXPORT_LOGS_BEGIN: 'GET_EXPORT_LOGS_BEGIN',
  GET_EXPORT_LOGS_SUCCESS: 'GET_EXPORT_LOGS_SUCCESS',
  GET_EXPORT_LOGS_ERR: 'GET_EXPORT_LOGS_ERR',

  getExportSettingsBegin: () => {
    return {
      type: actions.FETCH_EXPORT_SETTINGS_BEGIN,
    };
  },
  getExportSettingsSuccess: (data) => {
    return {
      type: actions.FETCH_EXPORT_SETTINGS_SUCCESS,
      data,
    };
  },
  getExportSettingsErr: (err) => {
    return {
      type: actions.FETCH_EXPORT_SETTINGS_ERR,
      err,
    };
  },

  updateExportSettingsBegin: () => {
    return {
      type: actions.UPDATE_EXPORT_SETTINGS_BEGIN,
    };
  },
  updateExportSettingsSuccess: (data) => {
    return {
      type: actions.UPDATE_EXPORT_SETTINGS_SUCCESS,
      data,
    };
  },

  updateExportSettingsErr: (err) => {
    return {
      type: actions.UPDATE_EXPORT_SETTINGS_ERR,
      err,
    };
  },

  getExportLogsBegin: () => {
    return {
      type: actions.GET_EXPORT_LOGS_BEGIN,
    };
  },
  getExportLogsSuccess: (data) => {
    return {
      type: actions.GET_EXPORT_LOGS_SUCCESS,
      data,
    };
  },

  getExportLogsErr: (err) => {
    return {
      type: actions.GET_EXPORT_LOGS_ERR,
      err,
    };
  },
};
export default actions;
